import React from "react";

var callSvg = function callSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.21 11.16l1.393-.824a.905.905 0 0 1 .968.03 760.125 760.125 0 0 1 3.094 2.093.956.956 0 0 1 .124 1.326 7.865 7.865 0 0 1-2.126 1.86c-1.596.942-3.199-.288-3.199-.288-1.302-.963-3.078-3.289-4.14-5.169-1.062-1.88-2.146-4.614-2.311-6.248 0 0-.24-2.033 1.356-2.975A7.709 7.709 0 0 1 6.008.013.924.924 0 0 1 7.07.786c.003.022.079 1.283.227 3.785a.947.947 0 0 1-.46.872l-1.394.82c.325 1.871 1.325 3.603 2.767 4.898z"
  }));
};

callSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var call = {
  category: 'icon',
  colorable: true,
  name: 'call',
  svg: callSvg
};